/*
 * @Author: Codex
 * @Date: 2026-04-22
 * @Description: 获取图片/视频尺寸工具函数
 */
import { isImageFile, isVideoFile } from './fileTypeDetector';
import { getImageDimensions, ImageDimensions } from './getImageDimensions';

/**
 * 获取视频尺寸
 * @param file - 视频文件
 * @returns Promise<ImageDimensions> - 视频宽高信息
 */
export const getVideoDimensions = (file: File): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    if (!file || !isVideoFile(file)) {
      reject(new Error('file is not a video'));
      return;
    }

    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
      });
    };

    video.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('load video failed'));
    };

    video.src = url;
  });
};

/**
 * 获取图片或视频尺寸
 * @param file - 图片或视频文件
 * @returns Promise<ImageDimensions> - 媒体宽高信息
 */
export const getMediaDimensions = (file: File): Promise<ImageDimensions> => {
  if (isImageFile(file)) {
    return getImageDimensions(file);
  }

  if (isVideoFile(file)) {
    return getVideoDimensions(file);
  }

  return Promise.reject(new Error('file must be image or video'));
};
